/**
 * @file paymentTypes.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-07-27
 * @modified 2026-07-27
 *
 * Shared helpers for describing Xero payment rows (payments.payments).
 * `paymentTypeLabel` → short label for a payment_type; `paymentNature` →
 * a plain-English description of what the payment represents and what it
 * was allocated against (invoice vs. bill). Used by SearchPayments and
 * PaymentBehaviourPanel so the wording stays consistent.
 */

export const PAYMENT_TYPE_LABELS = {
  ACCRECPAYMENT: 'Customer receipt',
  ACCPAYPAYMENT: 'Supplier payment',
  ARCREDITPAYMENT: 'Credit note refund',
  APCREDITPAYMENT: 'Supplier credit refund',
  AROVERPAYMENTPAYMENT: 'Overpayment',
  APOVERPAYMENTPAYMENT: 'Overpayment',
  ARPREPAYMENTPAYMENT: 'Prepayment',
  APPREPAYMENTPAYMENT: 'Prepayment'
};

export function paymentTypeLabel(type) {
  return PAYMENT_TYPE_LABELS[type] || type || 'Payment';
}

/**
 * Plain-English nature of a payment row, e.g.
 *   "Customer payment allocated against an invoice"
 *   "Credit note allocated against an invoice"
 *   "Supplier payment allocated against a bill"
 * The target kind (invoice/bill) is inferred from the linked document, so
 * callers that don't join invoice_no / bill_number get just the instrument.
 */
export function paymentNature(p) {
  const t = p.payment_type;
  const targetKind = p.invoice_no ? 'an invoice' : (p.bill_number ? 'a bill' : null);

  let instrument;
  switch (t) {
    case 'ACCRECPAYMENT': instrument = 'Customer payment'; break;
    case 'ACCPAYPAYMENT': instrument = 'Supplier payment'; break;
    case 'ARCREDITPAYMENT': instrument = 'Credit note'; break;
    case 'APCREDITPAYMENT': instrument = 'Supplier credit note'; break;
    case 'AROVERPAYMENTPAYMENT':
    case 'APOVERPAYMENTPAYMENT': instrument = 'Overpayment'; break;
    case 'ARPREPAYMENTPAYMENT':
    case 'APPREPAYMENTPAYMENT': instrument = 'Prepayment'; break;
    default: instrument = paymentTypeLabel(t);
  }

  return targetKind ? `${instrument} allocated against ${targetKind}` : instrument;
}
